import { HttpClient } from "@angular/common/http";
import { Component, Inject, Input, OnInit, SimpleChanges } from "@angular/core";
import { AuthService } from "@auth0/auth0-angular";
import { MessageService } from "primeng/api";

import {
  DialogService,
  DynamicDialogRef,
} from "primeng/dynamicdialog";
import { NGXLogger } from "ngx-logger";
import { DOCUMENT } from "@angular/common";
import { Router } from "@angular/router";


import { UtentiService } from "src/app/services/utenti.service";
import { UserService } from "src/app/services/user.service";
import { AngularFirestore } from "@angular/fire/compat/firestore";
import { StatsService } from "src/app/services/notification.service";
import { ImpreseService } from "src/app/services/imprese.service";

export let applicationVersionFromHome: string = "";

import { onSnapshot } from "firebase/firestore";
import { environment } from "src/environments/environment";
import { DatiSopralluogoPerImpresa, PraticaFlowdy2_Firestore } from "src/app/models/praticaFirestore.model";
import { StatsFlowdy2 } from "src/app/models/statsFlowdy2.model";
import { UtilService } from "src/app/services/util.service";
import { ExcelService } from "src/app/services/excelService.service";
import { ListeService } from "src/app/services/liste.service";


declare const CSVBoxImporter: any;

@Component({
  selector: "app-home-sopralluoghi",
  templateUrl: "./home.sopralluoghi.flowdy2.component.html",
  styleUrls: ["./home.component.css"],
})
export class HomeSopralluoghiFlowdy2Component implements OnInit {
  @Input() impresa: any;
  @Input() isImpresa: boolean     = null;
  @Input() isPresidioTIM: boolean = null;
  @Input() isPresidioSF: boolean  = null;

  ref: DynamicDialogRef;

  protected datiRaggruppatiBando1: DatiSopralluogoPerImpresa[] = [];
  protected datiRaggruppatiBando1Filtrati: DatiSopralluogoPerImpresa[] = [];
  protected datiRaggruppatiBando2Filtrati: DatiSopralluogoPerImpresa[] = [];
  protected datiRaggruppatiBando2: DatiSopralluogoPerImpresa[] = [];

  protected labelRegioni:string = "TUTTE LE REGIONI";

  protected isLoading: boolean = true;
  protected isAdmin:      boolean = false;
  protected isSuperAdmin: boolean = false;
  
  protected isDipendente: boolean = true;
  protected hasBando1: boolean = false;
  protected hasBando2: boolean = false;
  
  protected filtroRegione: string = '';

  protected filterIsSet: boolean = false;

  protected praticheBando1KO: PraticaFlowdy2_Firestore[]=[]
  protected praticheBando2KO: PraticaFlowdy2_Firestore[]=[]

  protected selectedPraticaBando1KO: PraticaFlowdy2_Firestore;
  protected selectedPraticaBando2KO: PraticaFlowdy2_Firestore;

  protected totaliBando1:number = 0;
  protected totaliNoSopralluogoBando1:number = 0;
  protected totaliNoSopralluogoPFBando1:number = 0;
  protected totaliSopralluogoPianificatoBando1:number = 0;
  protected totaliSopralluogoEseguitoBando1:number = 0;
  protected totaliSopralluogoKOBando1:number = 0;

  protected totaliBando2number = 0;
  protected totaliNoSopralluogoBando2:number = 0;
  protected totaliNoSopralluogoPFBando2:number = 0;
  protected totaliSopralluogoPianificatoBando2:number = 0;
  protected totaliSopralluogoEseguitoBando2:number = 0;
  protected totaliSopralluogoKOBando2:number = 0;

  protected totaliBando2:number = 0;


  protected activeTabIndex: number = 0; 

  private collection_pratiche:string  = environment.firebase.collection_pratiche;
  protected stats: StatsFlowdy2 = new StatsFlowdy2();

  constructor(
    public auth: AuthService,
    private http: HttpClient,
    private messageService: MessageService,
    private dipendenteService: UtentiService,
    private impreseService: ImpreseService,

    private userService: UserService,
    public dialogService: DialogService,
    private logger: NGXLogger,
    private router: Router,
    public firestore: AngularFirestore,
    private statsService: StatsService,
    public utilService:UtilService,
    public excelService:ExcelService,
    public listeService:ListeService,
    
    @Inject(DOCUMENT) private doc: Document
  ) {}

  ngOnInit() {
    this.logger.info("[HOME SOPRALLUOGHI] ON INIT");
  }

  onTabChange(event: any) {
    this.activeTabIndex = event.index; 
  }

 
   ngOnChanges(changes: SimpleChanges) {
       
      if (changes['impresa'] && changes['impresa'].currentValue) {
        this.impresa = changes['impresa'].currentValue;
      }
      if (changes['isImpresa'] && changes['isImpresa'].currentValue) {
        this.isImpresa = changes['isImpresa'].currentValue;
      }
      if (changes['isPresidioTIM'] && changes['isPresidioTIM'].currentValue) {
        this.isPresidioTIM = changes['isPresidioTIM'].currentValue;
      }
  
      if( (changes['isImpresa'] && changes['isImpresa'].currentValue) || (changes['isPresidioTIM'] && changes['isPresidioTIM'].currentValue) || (changes['impresa'] && changes['impresa'].currentValue)){
        this.loadDatiBando1();
        this.loadDatiBando2();
      }
    }

    scaricaReportSopralluoghi(){
      const today = new Date();
      const formattedDate = `${today.getDate().toString().padStart(2, '0')}_${(today.getMonth() + 1).toString().padStart(2, '0')}_${today.getFullYear()}`;
      if(this.activeTabIndex == 0){
        this.excelService.exportSopralluoghiToExcel(this.datiRaggruppatiBando1Filtrati, `report_sopralluoghi_${formattedDate}.xlsx`);

      }else if(this.activeTabIndex == 1){
        this.excelService.exportSopralluoghiToExcel(this.datiRaggruppatiBando2Filtrati, `report_sopralluoghi_${formattedDate}.xlsx`);

      }
    }

    openPraticheFase1DiImpresa(bando:number, idImpresa:number,impresa:string,statoSopralluogo:string){
      switch (statoSopralluogo) {
        case 'ALL':
          this.router.navigateByUrl('/', {skipLocationChange: true}).then(()=> this.router.navigate(['pratiche-bando'+bando+'/fase-1'],
            {
              queryParams: { 
                'impresa': idImpresa,
                'ragioneSocialeImpresa': impresa ,
              }, 
            }
          ));
          break;
        case 'noSopralluogo':
        case 'noSopralluogoPF':
        case 'sopralluogoPianificato':
        case 'sopralluogoEseguito':
        case 'sopralluogoKO':
          this.router.navigateByUrl('/', {skipLocationChange: true}).then(()=> this.router.navigate(['pratiche-bando'+bando+'/fase-1'],
            {
              queryParams: { 
                  'impresa': idImpresa ,
                  'ragioneSocialeImpresa': impresa ,
                  'statoSopralluogo': statoSopralluogo,
                  ...(this.filtroRegione ? { 'regione': this.filtroRegione } : {})
                }, 
            }
          ));
          break;
        default:
          this.router.navigateByUrl('/', {skipLocationChange: true}).then(()=> this.router.navigate(['pratiche-bando'+bando+'/fase-1'],
            {
              queryParams: { 'impresa': idImpresa }, 
            }
          ));
          break;
      }
      
     
    }
    
    
    loadDatiBando1(){

      this.isLoading = true;
      
      const collectionRef = this.firestore.collection(this.collection_pratiche).ref;
      let queryBando1  ;
      if(this.isImpresa){
        queryBando1 = collectionRef
                    .where("idAzienda", "==", this.userService.getUser().azienda.id)
                    .where("bando", "==", "BANDO 1")
                    .orderBy("azienda",'asc');
      }else{
        queryBando1 = collectionRef
                      .where("bando", "==", "BANDO 1")
                      .orderBy("azienda",'asc');
      }
      onSnapshot(queryBando1, (qs) => {
        this.isLoading = false;
        const raggruppamentoPerImpresa: { 
          [key: string]: { 
            idImpresa: number,
            //regione: string,
            totale: number,
            noSopralluogo: number,
            noSopralluogoPF: number,
            sopralluogoPianificato: number,
            sopralluogoEseguito: number,
            sopralluogoKO: number,
            datiPerRegione: {
              [regione: string]: {
                totale: number;
                noSopralluogo: number;
                noSopralluogoPF: number;
                sopralluogoPianificato: number;
                sopralluogoEseguito: number;
                sopralluogoKO: number;
              };
            };
          } 
        } = {};

        this.totaliBando1                         = 0;
        this.totaliNoSopralluogoBando1            = 0;
        this.totaliNoSopralluogoPFBando1          = 0;
        this.totaliSopralluogoPianificatoBando1   = 0;
        this.totaliSopralluogoEseguitoBando1      = 0;
        this.totaliSopralluogoKOBando1            = 0;
          qs.forEach((doc) => {
            let praticaBando1DaFirestore: PraticaFlowdy2_Firestore = doc.data() as PraticaFlowdy2_Firestore;
            const impresa = praticaBando1DaFirestore.azienda;
            const regione = praticaBando1DaFirestore.regione;

            if (!raggruppamentoPerImpresa[impresa]) {
              raggruppamentoPerImpresa[impresa] = { 
                idImpresa: praticaBando1DaFirestore.idAzienda,
                //regione: praticaBando1DaFirestore.regione, 
                totale: 0, 
                noSopralluogo: 0, 
                noSopralluogoPF: 0,
                sopralluogoPianificato: 0, 
                sopralluogoEseguito: 0,
                sopralluogoKO :0,
                datiPerRegione: {},
              };
            }
            if (!raggruppamentoPerImpresa[impresa].datiPerRegione[regione]) {
              raggruppamentoPerImpresa[impresa].datiPerRegione[regione] = {
                totale: 0,
                noSopralluogo: 0,
                noSopralluogoPF: 0,
                sopralluogoPianificato: 0,
                sopralluogoEseguito: 0,
                sopralluogoKO: 0,
              };
            }
            raggruppamentoPerImpresa[impresa].totale += 1;
            raggruppamentoPerImpresa[impresa].datiPerRegione[regione].totale += 1;

            if(praticaBando1DaFirestore.showFase2){
              
              if(!praticaBando1DaFirestore.dataSopralluogo || praticaBando1DaFirestore.dataSopralluogo == null){
                if(!praticaBando1DaFirestore.dataAppuntamentoFase2 || praticaBando1DaFirestore.dataAppuntamentoFase2== null){
                  raggruppamentoPerImpresa[impresa].noSopralluogoPF++;
                  raggruppamentoPerImpresa[impresa].datiPerRegione[regione].noSopralluogoPF++;
                }else{
                 
                  if(praticaBando1DaFirestore.statoFlowdyFase1==='SOPRALLUOGO EFFETTUATO'){
                    raggruppamentoPerImpresa[impresa].sopralluogoEseguito++;
                    raggruppamentoPerImpresa[impresa].datiPerRegione[regione].sopralluogoEseguito++;
                  }else{
                   if(praticaBando1DaFirestore.dataAppuntamentoFase2 && praticaBando1DaFirestore.statoFlowdyFase2 !== 'ATTIVAZIONE KO FO'){
                      raggruppamentoPerImpresa[impresa].sopralluogoPianificato++;
                      raggruppamentoPerImpresa[impresa].datiPerRegione[regione].sopralluogoPianificato++;
                    }else{
                      raggruppamentoPerImpresa[impresa].noSopralluogoPF++;
                      raggruppamentoPerImpresa[impresa].datiPerRegione[regione].noSopralluogoPF++;
                    }
                   
                  }
                 
                }
                

              }else{
                
                if(praticaBando1DaFirestore.statoFlowdyFase1==='SOPRALLUOGO EFFETTUATO' || (praticaBando1DaFirestore.sopralluogoOk && praticaBando1DaFirestore.dataSopralluogo)){
                  raggruppamentoPerImpresa[impresa].sopralluogoEseguito++;
                  raggruppamentoPerImpresa[impresa].datiPerRegione[regione].sopralluogoEseguito++;
                }else{
                 
                  raggruppamentoPerImpresa[impresa].sopralluogoPianificato++;
                  raggruppamentoPerImpresa[impresa].datiPerRegione[regione].sopralluogoPianificato++;
                }
              }
              //this.logger.info("SHOW FASE 2 " + praticaBando1DaFirestore.cui);
              
            }else{
              
              if(praticaBando1DaFirestore.statoFlowdyFase1==='IN ATTESA ODA' || praticaBando1DaFirestore.statoFlowdyFase1==='DA ASSEGNARE' || praticaBando1DaFirestore.statoFlowdyFase1==='ASSEGNATA'){
                //this.logger.info("NO SPR " + praticaBando1DaFirestore.cui);
               
                raggruppamentoPerImpresa[impresa].noSopralluogo++;
                raggruppamentoPerImpresa[impresa].datiPerRegione[regione].noSopralluogo++;

              }else if(praticaBando1DaFirestore.statoFlowdyFase1==='SOPRALLUOGO PIANIFICATO'){
                /* if(praticaBando1DaFirestore.azienda =='DELTA'){
                  this.logger.info("PRATICA DELTA CHE AGGIUNGO A PIANIFICATO "+ praticaBando1DaFirestore.cui + " "+ praticaBando1DaFirestore.statoFlowdyFase1 + " "+ praticaBando1DaFirestore.sopralluogoOk + " "+ praticaBando1DaFirestore.dataSopralluogo);
                }    */            
                raggruppamentoPerImpresa[impresa].sopralluogoPianificato++;
                raggruppamentoPerImpresa[impresa].datiPerRegione[regione].sopralluogoPianificato++;

              }else if(praticaBando1DaFirestore.statoFlowdyFase1==='SOPRALLUOGO KO'){
               
                raggruppamentoPerImpresa[impresa].sopralluogoKO++;
                raggruppamentoPerImpresa[impresa].datiPerRegione[regione].sopralluogoKO++;

              }else{
                
                if(praticaBando1DaFirestore.sopralluogoOk!==false){
                  //this.logger.info("OK " + praticaBando1DaFirestore.cui);
                 
                  raggruppamentoPerImpresa[impresa].sopralluogoEseguito++;
                  raggruppamentoPerImpresa[impresa].datiPerRegione[regione].sopralluogoEseguito++;

                }else{
                  
                  raggruppamentoPerImpresa[impresa].sopralluogoKO++;
                  raggruppamentoPerImpresa[impresa].datiPerRegione[regione].sopralluogoKO++;

                }
               
              }
            }
         });

          this.datiRaggruppatiBando1 = Object.entries(raggruppamentoPerImpresa).map(([impresa, dati]) => ({
            impresa,
            idImpresa:             dati.idImpresa,
            //regione:                dati.regione,
            totale:                 dati.totale,
            noSopralluogo:          dati.noSopralluogo,
            noSopralluogoPF:        dati.noSopralluogoPF,
            sopralluogoPianificato: dati.sopralluogoPianificato,
            sopralluogoEseguito:    dati.sopralluogoEseguito,
            sopralluogoKO:          dati.sopralluogoKO,
            datiPerRegione:         dati.datiPerRegione,

          }));
          this.datiRaggruppatiBando1Filtrati = this.datiRaggruppatiBando1;

          for (let index = 0; index < this.datiRaggruppatiBando1.length; index++) {
            this.totaliBando1                       += this.datiRaggruppatiBando1[index].totale;
            this.totaliNoSopralluogoBando1          += this.datiRaggruppatiBando1[index].noSopralluogo;
            this.totaliNoSopralluogoPFBando1        += this.datiRaggruppatiBando1[index].noSopralluogoPF;
            this.totaliSopralluogoPianificatoBando1 += this.datiRaggruppatiBando1[index].sopralluogoPianificato;
            this.totaliSopralluogoEseguitoBando1    += this.datiRaggruppatiBando1[index].sopralluogoEseguito;
            this.totaliSopralluogoKOBando1         += this.datiRaggruppatiBando1[index].sopralluogoKO;
            
          }
        
         // console.log("Dati raggruppati per impresa:", this.datiRaggruppatiBando1);
      });
    }

    removeFilter(){
      this.filterIsSet = false;
      this.filtroRegione = '';
      if(this.activeTabIndex==0){
        this.totaliBando1                         = 0;
        this.totaliNoSopralluogoBando1            = 0;
        this.totaliNoSopralluogoPFBando1          = 0;
        this.totaliSopralluogoPianificatoBando1   = 0;
        this.totaliSopralluogoEseguitoBando1      = 0;
        this.totaliSopralluogoKOBando1            = 0;

        this.datiRaggruppatiBando1Filtrati = [...this.datiRaggruppatiBando1];
        this.labelRegioni = "TUTTE LE REGIONI";
        for (let index = 0; index < this.datiRaggruppatiBando1Filtrati.length; index++) {
          this.totaliBando1                       += this.datiRaggruppatiBando1Filtrati[index].totale;
          this.totaliNoSopralluogoBando1          += this.datiRaggruppatiBando1Filtrati[index].noSopralluogo;
          this.totaliNoSopralluogoPFBando1        += this.datiRaggruppatiBando1Filtrati[index].noSopralluogoPF;
          this.totaliSopralluogoPianificatoBando1 += this.datiRaggruppatiBando1Filtrati[index].sopralluogoPianificato;
          this.totaliSopralluogoEseguitoBando1    += this.datiRaggruppatiBando1Filtrati[index].sopralluogoEseguito; 
          this.totaliSopralluogoKOBando1          += this.datiRaggruppatiBando1Filtrati[index].sopralluogoKO; 
        }
      }else if(this.activeTabIndex==1){
        this.totaliBando2                         = 0;
        this.totaliNoSopralluogoBando2            = 0;
        this.totaliNoSopralluogoPFBando2          = 0;
        this.totaliSopralluogoPianificatoBando2   = 0;
        this.totaliSopralluogoEseguitoBando2      = 0;
        this.totaliSopralluogoKOBando2            = 0;
        this.datiRaggruppatiBando2Filtrati = [...this.datiRaggruppatiBando2];
        this.labelRegioni = "TUTTE LE REGIONI";
        for (let index = 0; index < this.datiRaggruppatiBando2Filtrati.length; index++) {
          this.totaliBando2                       += this.datiRaggruppatiBando2Filtrati[index].totale;
          this.totaliNoSopralluogoBando2          += this.datiRaggruppatiBando2Filtrati[index].noSopralluogo;
          this.totaliNoSopralluogoPFBando2        += this.datiRaggruppatiBando2Filtrati[index].noSopralluogoPF;
          this.totaliSopralluogoPianificatoBando2 += this.datiRaggruppatiBando2Filtrati[index].sopralluogoPianificato;
          this.totaliSopralluogoEseguitoBando2    += this.datiRaggruppatiBando2Filtrati[index].sopralluogoEseguito; 
          this.totaliSopralluogoKOBando2    += this.datiRaggruppatiBando2Filtrati[index].sopralluogoKO; 
        }
      }
    }

    filtraPerRegione(selezione: string) {
      if(this.activeTabIndex==0){
        this.totaliBando1                         = 0;
        this.totaliNoSopralluogoBando1            = 0;
        this.totaliNoSopralluogoPFBando1          = 0;
        this.totaliSopralluogoPianificatoBando1   = 0;
        this.totaliSopralluogoEseguitoBando1      = 0;
        this.totaliSopralluogoKOBando1            = 0;
        if (!selezione) {
          this.filterIsSet = false;
          this.datiRaggruppatiBando1Filtrati = [...this.datiRaggruppatiBando1];
          this.labelRegioni = "TUTTE LE REGIONI";
          for (let index = 0; index < this.datiRaggruppatiBando1Filtrati.length; index++) {
            this.totaliBando1                       += this.datiRaggruppatiBando1Filtrati[index].totale;
            this.totaliNoSopralluogoBando1          += this.datiRaggruppatiBando1Filtrati[index].noSopralluogo;
            this.totaliNoSopralluogoPFBando1        += this.datiRaggruppatiBando1Filtrati[index].noSopralluogoPF;
            this.totaliSopralluogoPianificatoBando1 += this.datiRaggruppatiBando1Filtrati[index].sopralluogoPianificato;
            this.totaliSopralluogoEseguitoBando1    += this.datiRaggruppatiBando1Filtrati[index].sopralluogoEseguito;
            this.totaliSopralluogoKOBando1          += this.datiRaggruppatiBando1Filtrati[index].sopralluogoKO;
          }
        } else {
          this.filterIsSet = true;
          this.labelRegioni = "REGIONE " + selezione.toUpperCase();
  
          this.datiRaggruppatiBando1Filtrati = this.datiRaggruppatiBando1.map(dato => {
            const datiFiltratiPerRegione = Object.keys(dato.datiPerRegione)
              .filter(regione => regione === selezione)
              .reduce((acc, regione) => {
                const regioneData = dato.datiPerRegione[regione];
                acc.totale += regioneData.totale;
                acc.noSopralluogo += regioneData.noSopralluogo;
                acc.noSopralluogoPF += regioneData.noSopralluogoPF;
                acc.sopralluogoPianificato += regioneData.sopralluogoPianificato;
                acc.sopralluogoEseguito += regioneData.sopralluogoEseguito;
                acc.sopralluogoKO += regioneData.sopralluogoKO;
                return acc;
              }, {
                totale: 0,
                noSopralluogo: 0,
                noSopralluogoPF: 0,
                sopralluogoPianificato: 0,
                sopralluogoEseguito: 0,
                sopralluogoKO: 0,
              });
          
            return {
              ...dato,
              totale: datiFiltratiPerRegione.totale,
              noSopralluogo: datiFiltratiPerRegione.noSopralluogo,
              noSopralluogoPF: datiFiltratiPerRegione.noSopralluogoPF,
              sopralluogoPianificato: datiFiltratiPerRegione.sopralluogoPianificato,
              sopralluogoEseguito: datiFiltratiPerRegione.sopralluogoEseguito,
              sopralluogoKO: datiFiltratiPerRegione.sopralluogoKO,
              datiPerRegione: Object.fromEntries(
                Object.entries(dato.datiPerRegione)
                  .filter(([regione]) => regione === selezione)
              ),
            };
          }).filter(dato => dato.totale > 0);
          
          if(this.datiRaggruppatiBando1Filtrati.length > 0){
            for (let index = 0; index < this.datiRaggruppatiBando1Filtrati.length; index++) {
              this.totaliBando1                       += this.datiRaggruppatiBando1Filtrati[index].totale;
              this.totaliNoSopralluogoBando1          += this.datiRaggruppatiBando1Filtrati[index].noSopralluogo;
              this.totaliNoSopralluogoPFBando1        += this.datiRaggruppatiBando1Filtrati[index].noSopralluogoPF;
              this.totaliSopralluogoPianificatoBando1 += this.datiRaggruppatiBando1Filtrati[index].sopralluogoPianificato;
              this.totaliSopralluogoEseguitoBando1    += this.datiRaggruppatiBando1Filtrati[index].sopralluogoEseguito;
              this.totaliSopralluogoKOBando1          += this.datiRaggruppatiBando1Filtrati[index].sopralluogoKO;
            }
          }
        }
      }else if(this.activeTabIndex==1){
        this.totaliBando2                         = 0;
        this.totaliNoSopralluogoBando2            = 0;
        this.totaliNoSopralluogoPFBando2          = 0;
        this.totaliSopralluogoPianificatoBando2   = 0;
        this.totaliSopralluogoEseguitoBando2      = 0;
        this.totaliSopralluogoKOBando2      = 0;
      if (!selezione) {
        this.filterIsSet = false;
        this.datiRaggruppatiBando2Filtrati = [...this.datiRaggruppatiBando2];
        this.labelRegioni = "TUTTE LE REGIONI";
        for (let index = 0; index < this.datiRaggruppatiBando2Filtrati.length; index++) {
          this.totaliBando2                       += this.datiRaggruppatiBando2Filtrati[index].totale;
          this.totaliNoSopralluogoBando2          += this.datiRaggruppatiBando2Filtrati[index].noSopralluogo;
          this.totaliNoSopralluogoPFBando2        += this.datiRaggruppatiBando2Filtrati[index].noSopralluogoPF;
          this.totaliSopralluogoPianificatoBando2 += this.datiRaggruppatiBando2Filtrati[index].sopralluogoPianificato;
          this.totaliSopralluogoEseguitoBando2    += this.datiRaggruppatiBando2Filtrati[index].sopralluogoEseguito;
          this.totaliSopralluogoKOBando2    += this.datiRaggruppatiBando2Filtrati[index].sopralluogoKO;
          
        }
      } else {
        this.filterIsSet = true;
        this.labelRegioni = "REGIONE " + selezione.toUpperCase();

        this.datiRaggruppatiBando2Filtrati = this.datiRaggruppatiBando2.map(dato => {
          const datiFiltratiPerRegione = Object.keys(dato.datiPerRegione)
            .filter(regione => regione === selezione)
            .reduce((acc, regione) => {
              const regioneData = dato.datiPerRegione[regione];
              acc.totale += regioneData.totale;
              acc.noSopralluogo += regioneData.noSopralluogo;
              acc.noSopralluogoPF += regioneData.noSopralluogoPF;
              acc.sopralluogoPianificato += regioneData.sopralluogoPianificato;
              acc.sopralluogoEseguito += regioneData.sopralluogoEseguito;
              acc.sopralluogoKO += regioneData.sopralluogoKO;
              return acc;
            }, {
              totale: 0,
              noSopralluogo: 0,
              noSopralluogoPF: 0,
              sopralluogoPianificato: 0,
              sopralluogoEseguito: 0,
              sopralluogoKO: 0,
            });
        
          return {
            ...dato,
            totale: datiFiltratiPerRegione.totale,
            noSopralluogo: datiFiltratiPerRegione.noSopralluogo,
            noSopralluogoPF: datiFiltratiPerRegione.noSopralluogoPF,
            sopralluogoPianificato: datiFiltratiPerRegione.sopralluogoPianificato,
            sopralluogoEseguito: datiFiltratiPerRegione.sopralluogoEseguito,
            sopralluogoKO: datiFiltratiPerRegione.sopralluogoKO,
            datiPerRegione: Object.fromEntries(
              Object.entries(dato.datiPerRegione)
                .filter(([regione]) => regione === selezione)
            ),
          };
        }).filter(dato => dato.totale > 0);
        
        if(this.datiRaggruppatiBando2Filtrati.length > 0){
          for (let index = 0; index < this.datiRaggruppatiBando2Filtrati.length; index++) {
            this.totaliBando2                       += this.datiRaggruppatiBando2Filtrati[index].totale;
            this.totaliNoSopralluogoBando2          += this.datiRaggruppatiBando2Filtrati[index].noSopralluogo;
            this.totaliNoSopralluogoPFBando2        += this.datiRaggruppatiBando2Filtrati[index].noSopralluogoPF;
            this.totaliSopralluogoPianificatoBando2 += this.datiRaggruppatiBando2Filtrati[index].sopralluogoPianificato;
            this.totaliSopralluogoEseguitoBando2    += this.datiRaggruppatiBando2Filtrati[index].sopralluogoEseguito;
            this.totaliSopralluogoKOBando2          += this.datiRaggruppatiBando2Filtrati[index].sopralluogoKO;
          }
        }
      }
      }
      
    }
    

    loadDatiBando2(){
      this.isLoading = true;
      const collectionRef = this.firestore.collection(this.collection_pratiche).ref;
      let queryBando2  ;
      if(this.isImpresa){
          queryBando2 = collectionRef
                .where("idAzienda", "==", this.userService.getUser().azienda.id)
                .where("bando", "==", "BANDO 2")
                .orderBy("azienda",'asc');
        }else{
          queryBando2 = collectionRef
                .where("bando", "==", "BANDO 2")
                .orderBy("azienda",'asc');
  
      }
      onSnapshot(queryBando2, (qs) => {
        this.isLoading = false;
        this.totaliBando2                         = 0;
        this.totaliNoSopralluogoBando2            = 0;
        this.totaliNoSopralluogoPFBando2          = 0;
        this.totaliSopralluogoPianificatoBando2   = 0;
        this.totaliSopralluogoEseguitoBando2      = 0;
        this.totaliSopralluogoKOBando2      = 0;
        const raggruppamentoPerImpresa: { 
          [key: string]: { 
            idImpresa: number,
            totale: number,
            noSopralluogo: number,
            noSopralluogoPF: number,
            sopralluogoPianificato: number,
            sopralluogoEseguito: number,
            sopralluogoKO: number,
            datiPerRegione: {
              [regione: string]: {
                totale: number;
                noSopralluogo: number;
                noSopralluogoPF: number;
                sopralluogoPianificato: number;
                sopralluogoEseguito: number;
                sopralluogoKO: number;
              };
            };
          } 
        } = {};

        qs.forEach((doc) => {
            let praticaBando2DaFirestore: PraticaFlowdy2_Firestore = doc.data() as PraticaFlowdy2_Firestore;
            const impresa = praticaBando2DaFirestore.azienda;
            const regione = praticaBando2DaFirestore.regione;
            if (!raggruppamentoPerImpresa[impresa]) {
              raggruppamentoPerImpresa[impresa] = { 
                idImpresa: praticaBando2DaFirestore.idAzienda,
                //regione: praticaBando2DaFirestore.regione, 
                totale: 0, 
                noSopralluogo: 0, 
                noSopralluogoPF: 0,
                sopralluogoPianificato: 0, 
                sopralluogoEseguito: 0, 
                sopralluogoKO: 0 ,
                datiPerRegione: {},
              };
            }

            if (!raggruppamentoPerImpresa[impresa].datiPerRegione[regione]) {
              raggruppamentoPerImpresa[impresa].datiPerRegione[regione] = {
                totale: 0,
                noSopralluogo: 0,
                noSopralluogoPF: 0,
                sopralluogoPianificato: 0,
                sopralluogoEseguito: 0,
                sopralluogoKO: 0,
              };
            }
            raggruppamentoPerImpresa[impresa].totale += 1;
            raggruppamentoPerImpresa[impresa].datiPerRegione[regione].totale += 1;

              if(praticaBando2DaFirestore.showFase2){
                /* if(praticaBando2DaFirestore.azienda==='SITE'){
                  this.logger.info( praticaBando2DaFirestore.cui + " SHOW FASE 2 e con "+  praticaBando2DaFirestore.statoFlowdyFase1) ;
                } */
                if(!praticaBando2DaFirestore.dataSopralluogo || praticaBando2DaFirestore.dataSopralluogo == null){
                  if(!praticaBando2DaFirestore.dataAppuntamentoFase2 || praticaBando2DaFirestore.dataAppuntamentoFase2== null){
                    raggruppamentoPerImpresa[impresa].noSopralluogoPF++;
                    raggruppamentoPerImpresa[impresa].datiPerRegione[regione].noSopralluogoPF++;
                  }else{
                   
                    if(praticaBando2DaFirestore.statoFlowdyFase1==='SOPRALLUOGO EFFETTUATO'){
                      raggruppamentoPerImpresa[impresa].sopralluogoEseguito++;
                      raggruppamentoPerImpresa[impresa].datiPerRegione[regione].sopralluogoEseguito++;
                    }else{
                      
                     if(praticaBando2DaFirestore.dataAppuntamentoFase2 && praticaBando2DaFirestore.statoFlowdyFase2 !== 'ATTIVAZIONE KO FO'){
                        raggruppamentoPerImpresa[impresa].sopralluogoPianificato++;
                        raggruppamentoPerImpresa[impresa].datiPerRegione[regione].sopralluogoPianificato++;
                      }else{
                        raggruppamentoPerImpresa[impresa].noSopralluogoPF++;
                        raggruppamentoPerImpresa[impresa].datiPerRegione[regione].noSopralluogoPF++;
                      }
                     
                    }
                   
                  }
                  
  
                }else{
                  
                  if(praticaBando2DaFirestore.statoFlowdyFase1==='SOPRALLUOGO EFFETTUATO' || (praticaBando2DaFirestore.sopralluogoOk && praticaBando2DaFirestore.dataSopralluogo)){
                    raggruppamentoPerImpresa[impresa].sopralluogoEseguito++;
                    raggruppamentoPerImpresa[impresa].datiPerRegione[regione].sopralluogoEseguito++;
                  }else{
                   
                    raggruppamentoPerImpresa[impresa].sopralluogoPianificato++;
                    raggruppamentoPerImpresa[impresa].datiPerRegione[regione].sopralluogoPianificato++;
                  }
                }
                /* if(praticaBando2DaFirestore.statoFlowdyFase1==='SOPRALLUOGO KO'){
                  raggruppamentoPerImpresa[impresa].sopralluogoKO++;
                  raggruppamentoPerImpresa[impresa].datiPerRegione[regione].sopralluogoKO++;

                }else{
                  raggruppamentoPerImpresa[impresa].noSopralluogoPF++;
                  raggruppamentoPerImpresa[impresa].datiPerRegione[regione].noSopralluogoPF++;
                } */
               
              }else{
                if(praticaBando2DaFirestore.statoFlowdyFase1==='IN ATTESA ODA' || praticaBando2DaFirestore.statoFlowdyFase1==='DA ASSEGNARE' || praticaBando2DaFirestore.statoFlowdyFase1==='ASSEGNATA'){
                  raggruppamentoPerImpresa[impresa].noSopralluogo++;
                  raggruppamentoPerImpresa[impresa].datiPerRegione[regione].noSopralluogo++;

                }else if(praticaBando2DaFirestore.statoFlowdyFase1==='SOPRALLUOGO PIANIFICATO'){
                 
                  raggruppamentoPerImpresa[impresa].sopralluogoPianificato++;
                  raggruppamentoPerImpresa[impresa].datiPerRegione[regione].sopralluogoPianificato++;

                }else if(praticaBando2DaFirestore.statoFlowdyFase1==='SOPRALLUOGO KO'){
                  //this.logger.info("KO " + praticaBando2DaFirestore.cui);
  
                  raggruppamentoPerImpresa[impresa].sopralluogoKO++;
                  raggruppamentoPerImpresa[impresa].datiPerRegione[regione].sopralluogoKO++;
  
                }else{
                  if(praticaBando2DaFirestore.sopralluogoOk!==false){
                    raggruppamentoPerImpresa[impresa].sopralluogoEseguito++;
                    raggruppamentoPerImpresa[impresa].datiPerRegione[regione].sopralluogoEseguito++;

                  }else{
                    raggruppamentoPerImpresa[impresa].sopralluogoKO++;
                    raggruppamentoPerImpresa[impresa].datiPerRegione[regione].sopralluogoKO++;

                  }
                  
                  /* if((praticaBando2DaFirestore.codiceStatoInfratelFase1==='1-1' && !praticaBando2DaFirestore.showFase2) || 
                      praticaBando2DaFirestore.codiceStatoInfratelFase1==='1-2' || 
                      praticaBando2DaFirestore.codiceStatoInfratelFase1==='1-3' || 
                      praticaBando2DaFirestore.codiceStatoInfratelFase1==='1-4' || 
                      praticaBando2DaFirestore.codiceStatoInfratelFase1==='1-5'){
                    
                    } */
                 
                }
              }
            
            
         });

          this.datiRaggruppatiBando2 = Object.entries(raggruppamentoPerImpresa).map(([impresa, dati]) => ({
            impresa,
            idImpresa:             dati.idImpresa,
            //regione:               dati.regione,
            totale:                 dati.totale,
            noSopralluogo:          dati.noSopralluogo,
            noSopralluogoPF:        dati.noSopralluogoPF,
            sopralluogoPianificato: dati.sopralluogoPianificato,
            sopralluogoEseguito:    dati.sopralluogoEseguito,
            sopralluogoKO:          dati.sopralluogoKO,
            datiPerRegione:         dati.datiPerRegione,
          }));
          this.datiRaggruppatiBando2Filtrati = this.datiRaggruppatiBando2;

          for (let index = 0; index < this.datiRaggruppatiBando2.length; index++) {
            this.totaliBando2                         += this.datiRaggruppatiBando2[index].totale;
            this.totaliNoSopralluogoBando2            += this.datiRaggruppatiBando2[index].noSopralluogo;
            this.totaliNoSopralluogoPFBando2          += this.datiRaggruppatiBando2[index].noSopralluogoPF;
            this.totaliSopralluogoPianificatoBando2   += this.datiRaggruppatiBando2[index].sopralluogoPianificato;
            this.totaliSopralluogoEseguitoBando2      += this.datiRaggruppatiBando2[index].sopralluogoEseguito;
            this.totaliSopralluogoKOBando2          += this.datiRaggruppatiBando2[index].sopralluogoKO;
            
          }
             
        }); 
      
    }
  
  
}
